import {Routes} from '@angular/router';
import {PrimaryLayoutComponent} from './shared/layouts/primary-layout/primary-layout.component';
import {AuthLayoutComponent} from './shared/layouts/auth-layout/auth-layout.component';
import {authGuard} from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PrimaryLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard-routes').then(m => m.routes),
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./modules/maintenance/maintenance-routes').then(m => m.routes),
      },
      {
        path: 'search',
        loadChildren: () => import('./modules/search/search-routes').then(m => m.routes),
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin-routes').then(m => m.routes),
      },
      {
        path: 'monitor',
        loadChildren: () => import('./modules/monitor/monitor-routes').then(m => m.routes),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/auth/auth-routes').then(m => m.routes),
  },
  {
    path: 'error/page-not-found',
    // component: AuthLayoutComponent,
    loadComponent: () => import('./modules/error/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
  {
    path: '**',
    redirectTo: 'error/page-not-found',
  },
];
